
import { Facebook, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Company Section */}
      <div className="border-b border-gray-700/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4">TopMotorPart</h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Your trusted partner in automotive parts export
            </p>
            <address className="text-gray-400 not-italic">
              P.S. Jain motor market, 69, Kashmere Gate,<br />
              Delhi, 110006, India
            </address>
          </div>
        </div>
      </div>

      {/* Three Column Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Quick Links Column */}
          <div className="space-y-6">
            <h3 className="text-xl font-semibold after:content-[''] after:block after:w-12 after:h-1 after:bg-primary after:mt-2">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 inline-block relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-primary after:transition-all hover:after:w-full">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 inline-block relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-primary after:transition-all hover:after:w-full">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 inline-block relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-primary after:transition-all hover:after:w-full">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" 
                  className="text-gray-400 hover:text-white transition-colors duration-200 inline-block relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-px after:bg-primary after:transition-all hover:after:w-full">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Exporter Details Column */}
          <div className="space-y-6">
            <h3 className="text-xl font-semibold after:content-[''] after:block after:w-12 after:h-1 after:bg-primary after:mt-2">
              Exporter Details
            </h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-center space-x-2">
                <span className="text-gray-500">COMPANY NAME:</span>
                <span>Aleron Export</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="text-gray-500">WEBSITE:</span>
                <a href="aleronexport.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors">
                  aleronexport.com
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <span className="text-gray-500">GSTIN:</span>
                <span>24AGOPU2832Q1ZM</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="text-gray-500">Bank:</span>
                <span>Kotak Mahindra Bank</span>
              </li>
            </ul>
          </div>

          {/* Connect Column */}
          <div className="space-y-6">
            <h3 className="text-xl font-semibold after:content-[''] after:block after:w-12 after:h-1 after:bg-primary after:mt-2">
              Connect With Us
            </h3>
            <div className="space-y-4">
              <div className="space-y-2">
                <p className="text-gray-400">
                  <span className="text-gray-500">Phone:</span>{" "}
                  <a href="tel:+919810391385" className="hover:text-white transition-colors">
                    +91 9810391385
                  </a>
                </p>
                <p className="text-gray-400">
                  <span className="text-gray-500">Email:</span>{" "}
                  <a href="mailto:info@topmotorpart.com" className="hover:text-white transition-colors">
                    info@topmotorpart.com
                  </a>
                </p>
              </div>
              
              <div className="pt-4 border-t border-gray-700/50">
                <div className="flex space-x-4">
                  <a 
                    href="https://www.facebook.com/profile.php?id=61572583258377" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-white transition-colors duration-200 transform hover:scale-110"
                  >
                    <Facebook size={24} />
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/top-motor-part/about/?viewAsMember=true" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-white transition-colors duration-200 transform hover:scale-110"
                  >
                    <Linkedin size={24} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <p className="text-center text-gray-400">
            &copy; {new Date().getFullYear()} TopMotorPart. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
